import { Link } from "react-router-dom";

const Vip = () => {
  return (
    <div className="wrapper">
      <div className="container-web home bank">
        <div
          className="d-flex align-items-center justify-content-between px-3"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 999,
            background: "#0262b0",
            height: 50,
            maxWidth: 500,
            margin: "auto",
            color: "#fff",
          }}
        >
          <Link to="/">
            <i
              style={{ color: "#fff" }}
              className="fa-solid fa-chevron-left"
            ></i>
          </Link>
          <div>VIP</div>
          <div></div>
        </div>
        <div style={{ paddingTop: 50 }}></div>

        <div className="p-4" style={{ fontSize: 14, fontWeight: 500 }}>
          <h6 className="fw-bold">Thành viên Bạc 0,00$</h6>
          <p>
            - Số lượt rút tiền: 1/ngày <br />
            - Số tiền rút tối đa: 1.000.000 <br />
            - Số lượng nhiệm vụ: 60/ngày <br />
            - Tỉ lệ hoa hồng: 0.6% <br />
            - Thành viên vĩnh viễn <br />
          </p>

          <h6 className="fw-bold">Thành viên vàng 1.000$</h6>
          <p>
            - Số lượt rút tiền: 1/ngày <br />
            - Số tiền rút tối đa: 10.000.000 <br />
            - Số lượng nhiệm vụ: 80/ngày <br />
            - Tỉ lệ hoa hồng: 1% <br />
            - Thành viên vĩnh viễn <br />
          </p>

          <h6 className="fw-bold">Thành viên Bạch Kim 5.000$</h6>
          <p>
            - Số lượt rút tiền: 1/ngày <br />
            - Số tiền rút tối đa: 100.000.000 <br />
            - Số lượng nhiệm vụ: 100/ngày <br />
            - Tỉ lệ hoa hồng: 1.5% <br />
            - Thành viên vĩnh viễn <br />
          </p>

          <h6 className="fw-bold">Thành viên Kim Cương 10.000$</h6>
          <p>
            - Số lượt rút tiền: 1/ngày <br />
            - Số tiền rút tối đa: 1.000.000.000 <br />
            - Số lượng nhiệm vụ: 120/ngày <br />
            - Tỉ lệ hoa hồng: 1.9% <br />
            - Thành viên vĩnh viễn <br />
          </p>
        </div>
      </div>
    </div>
  );
};

export default Vip;
